export type UseReferrerHook = {
    isInternal: boolean;
    url: URL | undefined;
};

export const useReferrer = (): UseReferrerHook => {
    let url: URL | undefined;
    try {
        url = new URL(document.referrer);
    } catch {
        // if document.referrer is for some reason not parsable, don't fail
    }
    return {
        isInternal: url?.origin === window.origin && window.history.length > 1,
        url,
    };
};
